import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from '../pages/Home';
import ServicesPage from '../pages/Services';
import ServiceDetail from '../pages/Services/ServiceDetail';
import SpecialitiesPage from '../pages/Specialities';
import { routeNames } from './routeNames';
import SpecialitiesDetail from '../pages/Specialities/SpecialitiesDetail';
import Testimonials from '../pages/Testinomials';
import TestinomialDetailPage from '../pages/Testinomials/TestinomialDetail';
import ShareYourStory from '../pages/Testinomials/ShareYourStory';
import BlogPage from '../pages/Blog';
import BlogDetail from '../pages/Blog/BlogDetail';
import ContactUsPage from '../pages/ContactUs';
import PatientForms from '../pages/PatientForm';
import NewPatientForm from '../pages/PatientForm/NewPatientForm';
import AboutUs from '../pages/Aboutus';
import TeamMemberDetail from '../pages/Aboutus/TeamMemberDetail';
import ScrollToTop from '../hooks/ScrollToTop/indexl';
import Demo from '../pages/Demo';


const AppRoutes = () => (
  <Router>
     <ScrollToTop />
    <Routes>
      <Route path={routeNames.home} element={<HomePage />} />
      <Route path={routeNames.services} element={<ServicesPage />} />
      <Route path={routeNames.servicesDetail} element={<ServiceDetail />} />
      
      <Route path={routeNames.specialities} element={<SpecialitiesPage />} />
      <Route path={routeNames.specialitiesDetail} element={<SpecialitiesDetail />} />

      <Route path={routeNames.testinomials} element={<Testimonials />} />
      <Route path={routeNames.testinomialsDetail} element={<TestinomialDetailPage />} />
      <Route path={routeNames.testinomialsShareYourStory} element={<ShareYourStory />} />

      <Route path={routeNames.Blog} element={<BlogPage />} />
      <Route path={routeNames.blogDetail} element={<BlogDetail />} />

      <Route path={routeNames.patientinfo} element={<PatientForms />} />
      <Route path={routeNames.newpatientform} element={<NewPatientForm />} />

      <Route path={routeNames.contact} element={<ContactUsPage />} />
      
      <Route path={routeNames.aboutus} element={<AboutUs />} />
      <Route path={routeNames.teammemberdetail} element={<TeamMemberDetail />} />

      <Route path={routeNames.demo} element={<Demo />} />
      
    </Routes>
  </Router>
);

export default AppRoutes;
